import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Products.css';
import Section from "../../../../components/Clientes/Section/Section";
import {ReactComponent as RigthArrow} from '../../../../assets/systemIcons/rigth_arrow.svg';
import useWindowDimensions from "../../../../components/Utils/useWindowDimensions";
import { trackClick, getElementName } from "../../../../utils/analytics/analytics";
import { ANALYTICS_MODULES, ANALYTICS_SECTIONS, ANALYTICS_ELEMENT_TYPES } from "../../../../constants/analyticsConstants";

function Products() {
    const navigate = useNavigate();
    const {width} = useWindowDimensions();
    const isMobile = width < 481;

    return (
        <Section height={isMobile ? '660px' : ''}>
            <div className="clientes__products__container">
                <div className="clientes__products__bodyContainer">
                    <h1 className="clientes__products__title">Productos</h1>
                    <h2 className="clientes__products__description">
                        Cotizá el seguro que estás buscando y recibí ayuda de un productor experto.
                    </h2>

                    <div className="clientes__products__productsContainer">
                        <button
                            className="clientes__products__button"
                            onClick={() => {
                                trackClick({
                                    module: ANALYTICS_MODULES.LANDING,
                                    section: ANALYTICS_SECTIONS.LANDING_PRODUCTS,
                                    elementName: getElementName(ANALYTICS_ELEMENT_TYPES.BUTTON, ANALYTICS_SECTIONS.LANDING_PRODUCTS, 'automotor'),
                                    elementType: ANALYTICS_ELEMENT_TYPES.BUTTON
                                });
                                navigate("/cotizar/automotor");
                            }}
                        >
                            <img
                                src="https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/automotor.webp"
                                alt="Automotor"
                                className="clientes__products__img"
                            />
                            <div className="clientes__products__contentContainer">
                                <p className="clientes__products__buttonText">Automotor</p>
                                <RigthArrow className="clientes__products__arrow"/>
                            </div>
                        </button>

                        <button
                            className="clientes__products__button"
                            onClick={() => {
                                trackClick({
                                    module: ANALYTICS_MODULES.LANDING,
                                    section: ANALYTICS_SECTIONS.LANDING_PRODUCTS,
                                    elementName: getElementName(ANALYTICS_ELEMENT_TYPES.BUTTON, ANALYTICS_SECTIONS.LANDING_PRODUCTS, 'motovehiculo'),
                                    elementType: ANALYTICS_ELEMENT_TYPES.BUTTON
                                });
                                navigate("/cotizar/motovehículo");
                            }}
                        >
                            <img
                                src="https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/motovehiculo.webp"
                                alt="Motovehículo"
                                className="clientes__products__img"
                            />
                            <div className="clientes__products__contentContainer">
                                <p className="clientes__products__buttonText">Motovehículo</p>
                                <RigthArrow className="clientes__products__arrow"/>
                            </div>
                        </button>

                        <button
                            className="clientes__products__button"
                            onClick={() => {
                                trackClick({
                                    module: ANALYTICS_MODULES.LANDING,
                                    section: ANALYTICS_SECTIONS.LANDING_PRODUCTS,
                                    elementName: getElementName(ANALYTICS_ELEMENT_TYPES.BUTTON, ANALYTICS_SECTIONS.LANDING_PRODUCTS, 'hogar'),
                                    elementType: ANALYTICS_ELEMENT_TYPES.BUTTON
                                });
                                navigate("/cotizar/hogar");
                            }}
                        >
                            <img
                                src="https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/hogar.webp"
                                alt="Hogar"
                                className="clientes__products__img"
                            />
                            <div className="clientes__products__contentContainer">
                                <p className="clientes__products__buttonText">Hogar</p>
                                <RigthArrow className="clientes__products__arrow"/>
                            </div>
                        </button>

                        <button
                            className="clientes__products__button"
                            onClick={() => {
                                trackClick({
                                    module: ANALYTICS_MODULES.LANDING,
                                    section: ANALYTICS_SECTIONS.LANDING_PRODUCTS,
                                    elementName: getElementName(ANALYTICS_ELEMENT_TYPES.BUTTON, ANALYTICS_SECTIONS.LANDING_PRODUCTS, 'asistencia_viajero'),
                                    elementType: ANALYTICS_ELEMENT_TYPES.BUTTON
                                });
                                navigate("/cotizar/asistenciaviajero");
                            }}
                        >
                            <img
                                src="https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/products/asistencia-al-viajero.webp"
                                alt="Asistencia al viajero"
                                className="clientes__products__img"
                            />
                            <div className="clientes__products__contentContainer">
                                <p className="clientes__products__buttonText">Asistencia al viajero</p>
                                <RigthArrow className="clientes__products__arrow"/>
                            </div>
                        </button>

                        <button
                            className="clientes__products__buttonMoreProducts"
                            onClick={() => {
                                trackClick({
                                    module: ANALYTICS_MODULES.LANDING,
                                    section: ANALYTICS_SECTIONS.LANDING_PRODUCTS,
                                    elementName: getElementName(ANALYTICS_ELEMENT_TYPES.BUTTON, ANALYTICS_SECTIONS.LANDING_PRODUCTS, 'ver_todos'),
                                    elementType: ANALYTICS_ELEMENT_TYPES.BUTTON
                                });
                                navigate("/productos");
                            }}
                        >
                            <p className="clientes__products__buttonText">Ver todos los productos</p>
                            <RigthArrow className="clientes__products__arrowMoreProducts"/>
                        </button>
                    </div>
                </div>
            </div>
        </Section>
    )
        ;
}

export default Products;